export const ENV_DEV = {
  API: {
    TRAVEL: 'https://microservices.dev.rappi.com/ms-travel/',
    PROFILE: 'https://microservices.dev.rappi.com/ms-profile/',
    RULES: 'https://microservices.dev.rappi.com/ms-rule-engine/',
    LOGIN: 'https://v2.dev.rappi.com/api/rocket/login/password/application_user',
    USER: 'https://v2.dev.rappi.com/ms/application-user/auth',
    COUNTRIES: 'https://restcountries.eu/rest/v2/',
    LOGIN_EXCHANGE: 'https://v2.dev.rappi.com/api/rocket/exchange/authorization_code',
    RAPPI_SERVICES: 'https://v2.dev.rappi.com/api/',
    RAPPI_SERVICES_CITIES: 'https://v2.dev.rappi.com/api/travel/search/',
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: 'https://microservices.dev.rappi.com/api/travel-city-search/',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: 'https://microservices.dev.rappi.com/api/travel-hotel-search/',
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: 'https://scapi-testing.netactica.com/hotel-location/',
    RAPPI_IMAGES_CDN: 'https://images.rappi.com/',
  },
  API_KEYS: {
    GOOGLE_MAPS_API_KEY: 'AIzaSyC85YET8koiA73IEC8rwNm3i2zvs3o2YvQ',
    KUSTOMER_FORM_ID: '5f524de4f0a0d900963139d2',
    AMPLITUDE_KEY: 'f754f0caafc5e6ccf74df0675187d9e5',
  },
  RAPPI_OAUTH: {
    REDIRECT_URL_FROM_LOGIN: 'https://travel-corporate.dev.rappi.com/oauth-login',
    REDIRECT_URL_FROM_REGISTRATION: 'https://travel-corporate.dev.rappi.com/oauth-registration',
    REDIRECT_URL_FROM_INVITE: 'https://travel-corporate.dev.rappi.com/oauth-invite',
    LOGIN_CLIENTID: 'Ax58lfzZNB9PlLcg5npqCHPC4bUUkMR2Nmmt3tYr',
    LOGIN_URL: 'https://www.dev.rappi.com/login-legacy',
    SIGNUP_URL: 'https://www.dev.rappi.com/login-legacy/signup',
  },
  LANDING_PAGE: 'https://travel4business.dev.rappi.com/',
  SENTRY_DSN: 'https://fe011ed6ec14461595fd1716c48e310d@o484725.ingest.sentry.io/5538357',
  SEARCH_MAX_RESULT_PER_PAGE: 9,
  COUNTRY_CODE: 0,
  RAPPI_BRANCH_CODE: 'APP1',
};
